import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";
import './modal_info_sanierungsfahrplan.css';

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';
import { ModalClose } from '../components/modal-close.tsx';

export default function ModalInfoSanierungsfahrplan() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Was bedeutet individueller Sanierungsfahrplan (iSFP)?</h1>
            <p id="modal-description">Maßnahmen, die im individuellen Sanierungsfahrplan (iSFP) empfohlen werden, erhalten eine höhere Förderung. Für die erste Wohneinheit steigen die förderfähigen Kosten von 30.000 € auf 60.000 €. Die Kosten über 30.000 € werden zusätzlich mit einem iSFP-Bonus von 5 % gefördert.</p>            
            <figure>
                <legend>BEG-Einzelmaßnahme Beispielrechnung Einfamilienhaus</legend>
                <table className="isptable" cellSpacing="0" cellpadding="0" border="0"> 
                <tr>
                    <th><b>Anzahl Wohn&shy;einheiten</b></th>
                    <th><b>Grund&shy;förderung</b> <small>15% Zuschuss bis</small></th>
                    <th><b>Mit iSFP zusätzlich</b> <small>20% Zuschuss auf den Bereich</small></th>
                    <th><b>Max. förder&shy;fähige Kosten</b></th>
                    <th><b>Maximale Förderung</b> <small>mit iSFP</small></th>
                    <th><b>Maximale Förderung</b> <small>ohne iSFP</small></th>
                </tr>

                <tr>
                    <td>1 WE</td>
                    <td>30.000 €</td>
                    <td>30.000 - 60.000 €</td>
                    <td>60.000 €</td>		
                    <td>10.500 €</td>
                    <td>4.500 €</td>
                </tr>
                <tr>
                    <td>2 WE</td>
                    <td>45.000 €</td>
                    <td>45.000 - 90.000 €</td>
                    <td>90.000 €</td>		
                    <td>15.750 €</td>
                    <td>6.750 €</td>
                </tr>
                <tr>
                    <td>3 WE</td>
                    <td>60.000 €</td>
                    <td>60.000 - 120.000 €</td>
                    <td>120.000 €</td>		
                    <td>21.000 €</td>
                    <td>9.000 €</td>
                </tr>
                <tr>
                    <td>4 WE</td>
                    <td>75.000 €</td>
                    <td>75.000 - 150.000 €</td>
                    <td>150.000 €</td>		
                    <td>26.250 €</td>
                    <td>11.250 €</td>
                </tr>
                <tr>
                    <td>5 WE</td>
                    <td>90.000 €</td>
                    <td>90.000 - 180.000 €</td>
                    <td>180.000 €</td>		
                    <td>31.500 €</td>
                    <td>13.500 €</td>
                </tr>
                <tr>
                    <td>6 WE</td>
                    <td>105.000 €</td>
                    <td>105.000 - 210.000 €</td>
                    <td>210.000 €</td>		
                    <td>36.750 €</td>
                    <td>15.750 €</td>
                </tr>
                <tr>
                    <td>7 WE</td>
                    <td>113.000 €</td>
                    <td>113.000 - 210.000 €</td>
                    <td>210.000 €</td>		
                    <td>39.550 €</td>
                    <td>16.950 €</td>
                </tr>
                 <tr>
                    <td>8 WE</td>
                    <td>121.000 €</td>
                    <td>121.000 - 242.000 €</td>
                    <td>242.000 €</td>		
                    <td>42.350 €</td>
                    <td>18.150 €</td>
                </tr>
                </table>
            </figure>
           
             <ModalClose label={"weiter"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

